__turbopack_context__.v({
  "h1": "UmNYqG_h1",
  "sectionPadding": "UmNYqG_sectionPadding",
});
